import { render, staticRenderFns } from "./DashboardLayoutDay.vue?vue&type=template&id=5b4bb0c1&scoped=true&"
import script from "./DashboardLayoutDay.vue?vue&type=script&lang=ts&"
export * from "./DashboardLayoutDay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4bb0c1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
